import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export const LANE_KEYS = [
  "upcoming_follow_up",
  "overdue",
  "system_followed_up",
  "at_risk",
];

export const LANE_CONFIG = {
  upcoming_follow_up: {
    label: "Upcoming Follow-Up",
    mobileLabel: "Upcoming",
    sub: "Due today or scheduled later",
    Icon: AccessTimeIcon,
    dotColor: "#f59e0b",
    // Header gradient
    bgLight: "linear-gradient(135deg, rgba(245,158,11,0.12) 0%, rgba(245,158,11,0.04) 100%)",
    bgDark:  "linear-gradient(135deg, rgba(245,158,11,0.18) 0%, rgba(245,158,11,0.06) 100%)",
    // Lane border
    borderLight: "rgba(245, 158, 11, 0.28)",
    borderDark:  "rgba(245, 158, 11, 0.22)",
    // Count pill
    chipBgLight: "rgba(245, 158, 11, 0.14)",
    chipTextLight: "#92400e",
    chipBgDark:  "rgba(245, 158, 11, 0.22)",
    chipTextDark: "#fcd34d",
  },
  overdue: {
    label: "Overdue",
    mobileLabel: "Overdue",
    sub: "Rep missed follow-up",
    Icon: HourglassBottomIcon,
    dotColor: "#ef4444",
    bgLight: "linear-gradient(135deg, rgba(239,68,68,0.10) 0%, rgba(239,68,68,0.03) 100%)",
    bgDark:  "linear-gradient(135deg, rgba(239,68,68,0.18) 0%, rgba(239,68,68,0.06) 100%)",
    borderLight: "rgba(239, 68, 68, 0.25)",
    borderDark:  "rgba(239, 68, 68, 0.22)",
    chipBgLight: "rgba(239, 68, 68, 0.12)",
    chipTextLight: "#991b1b",
    chipBgDark:  "rgba(239, 68, 68, 0.22)",
    chipTextDark: "#fca5a5",
  },
  system_followed_up: {
    label: "System Followed Up",
    mobileLabel: "System",
    sub: "Auto email / SMS sent",
    Icon: AutorenewIcon,
    dotColor: "#0ea5e9",
    bgLight: "linear-gradient(135deg, rgba(14,165,233,0.09) 0%, rgba(14,165,233,0.03) 100%)",
    bgDark:  "linear-gradient(135deg, rgba(14,165,233,0.18) 0%, rgba(14,165,233,0.06) 100%)",
    borderLight: "rgba(14, 165, 233, 0.25)",
    borderDark:  "rgba(14, 165, 233, 0.22)",
    chipBgLight: "rgba(14, 165, 233, 0.12)",
    chipTextLight: "#0c4a6e",
    chipBgDark:  "rgba(14, 165, 233, 0.22)",
    chipTextDark: "#7dd3fc",
  },
  at_risk: {
    label: "At Risk",
    mobileLabel: "At Risk",
    sub: "Needs manager attention",
    Icon: WarningAmberIcon,
    dotColor: "#8b5cf6",
    bgLight: "linear-gradient(135deg, rgba(139,92,246,0.10) 0%, rgba(139,92,246,0.03) 100%)",
    bgDark:  "linear-gradient(135deg, rgba(139,92,246,0.18) 0%, rgba(139,92,246,0.06) 100%)",
    borderLight: "rgba(139, 92, 246, 0.25)",
    borderDark:  "rgba(139, 92, 246, 0.22)",
    chipBgLight: "rgba(139, 92, 246, 0.12)",
    chipTextLight: "#4c1d95",
    chipBgDark:  "rgba(139, 92, 246, 0.22)",
    chipTextDark: "#c4b5fd",
  },
};

// Heat level chip colors — used on overdue / at_risk cards
export const HEAT_PALETTE = {
  yellow: {
    light: { bg: "#fef3c7", text: "#92400e", border: "#fde68a" },
    dark:  { bg: "rgba(245,158,11,0.2)", text: "#fcd34d", border: "rgba(245,158,11,0.35)" },
  },
  orange: {
    light: { bg: "#ffedd5", text: "#7c2d12", border: "#fed7aa" },
    dark:  { bg: "rgba(249,115,22,0.2)", text: "#fdba74", border: "rgba(249,115,22,0.35)" },
  },
  red: {
    light: { bg: "#fee2e2", text: "#7f1d1d", border: "#fca5a5" },
    dark:  { bg: "rgba(239,68,68,0.2)", text: "#fca5a5", border: "rgba(239,68,68,0.35)" },
  },
};
